import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import InputLabel from '@material-ui/core/InputLabel';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import { useDebounce } from 'use-debounce';

import styles from './CaseManagerSearch.style';
import BootstrapInput from '../../Shared/BootstrapInput/BootstrapInput';

const CaseManagerSearch = props => {
	const { 
		classes,
		searchFilters, 
		setSearchFilters } = props;

	const [internalSearchFilters, setInternalSearchFilters] = useState({
		...searchFilters
	});

	const [debouncedSearchFilters] = useDebounce(internalSearchFilters, 500);

	useEffect(() => {
		setInternalSearchFilters({ ...searchFilters });
	}, [searchFilters])

	useEffect(() => {
		if (debouncedSearchFilters) {
			if (debouncedSearchFilters.orderNumber !== searchFilters.orderNumber ||
				debouncedSearchFilters.claimantName !== searchFilters.claimantName ||
				debouncedSearchFilters.contact !== searchFilters.contact ||
				debouncedSearchFilters.claimNumber !== searchFilters.claimNumber ||
				debouncedSearchFilters.firmFileNumber !== searchFilters.firmFileNumber
			) {
				setSearchFilters(debouncedSearchFilters);
			}
		}
	}, [debouncedSearchFilters, searchFilters, setSearchFilters]);

	const onOrderNoChange = e => {
		setInternalSearchFilters({ ...searchFilters, orderNumber: e.target.value });
	};

	const onClaimantNameChange = e => {
		setInternalSearchFilters({ ...searchFilters, claimantName: e.target.value });
	};

	const onContactChange = e => {
		setInternalSearchFilters({ ...searchFilters, contact: e.target.value });
	};

	const onClaimNoChange = e => {
		setInternalSearchFilters({ ...searchFilters, claimNumber: e.target.value });
	};

	const onFirmFileNoChange = e => {
		setInternalSearchFilters({ ...searchFilters, firmFileNumber: e.target.value });
	};

	return (
		<div>
			<Paper elevation={0} className={classes.searchPaper}>
				<Grid container spacing={2}>
					<Grid item xs={6}>
						<InputLabel shrink className={classes.inputLabel}>
							Order Number
						</InputLabel>
						<FormControl fullWidth>
							<BootstrapInput
								id='orderNo'
								value={internalSearchFilters.orderNumber}
								maxLength='20'
								onChange={onOrderNoChange}
							/>
						</FormControl>
					</Grid>
					<Grid item xs={6}>
						<InputLabel shrink className={classes.inputLabel}>
							Claimant Name
						</InputLabel>
						<FormControl fullWidth>
							<BootstrapInput
								id='claimantName'
								value={internalSearchFilters.claimantName}
								maxLength='80'
								onChange={onClaimantNameChange}
							/>
						</FormControl>
					</Grid>
					<Grid item xs={6}>
						<InputLabel shrink className={classes.inputLabel}>
							Main Contact
						</InputLabel>
						<FormControl fullWidth>
							<BootstrapInput
								id='contact'
								value={internalSearchFilters.contact}
								maxLength='80'
								onChange={onContactChange}
							/>
						</FormControl>
					</Grid>
					<Grid item xs={3}>
						<InputLabel shrink className={classes.inputLabel}>
							Claim No
						</InputLabel>
						<FormControl fullWidth>
							<BootstrapInput
								id='claimNo'
								value={internalSearchFilters.claimNumber}
								maxLength='40'
								onChange={onClaimNoChange}
							/>
						</FormControl>
					</Grid>
					<Grid item xs={3}>
						<InputLabel shrink className={classes.inputLabel}>
							Firm File No
						</InputLabel>
						<FormControl fullWidth>
							<BootstrapInput
								id='firmFileNo'
								value={internalSearchFilters.firmFileNumber}
								maxLength='24'
								onChange={onFirmFileNoChange}
							/>
						</FormControl>
					</Grid>
				</Grid>
			</Paper>
		</div>
	);
};

CaseManagerSearch.propTypes = {
	classes: PropTypes.object.isRequired,
	searchFilters: PropTypes.shape({
		orderNumber: PropTypes.string,
		claimantName: PropTypes.string,
		contact: PropTypes.string,
		claimNumber: PropTypes.string,
		firmFileNumber: PropTypes.string
	}).isRequired,
	setSearchFilters: PropTypes.func.isRequired
};

export default withStyles(styles)(CaseManagerSearch);
